var oldStartup = __webpack_require__.x;
var hasRun = false;
__webpack_require__.x = () => {
	if (!hasRun) {
	  hasRun = true;
	  __webpack_require__(/*! ./node_modules/.federation/entry.990402b16c3f6029877a96b77cbf3ae3.js */ "./node_modules/.federation/entry.990402b16c3f6029877a96b77cbf3ae3.js");
	}
	return oldStartup();
};